import { useDeleteBankAccount } from '@api';
import { AxiosError } from 'axios';
import { useNotification } from '../../../useNotification';

const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.DELETE_BANK_ACCOUNT';

type UseDeleteBankAccountMutationReturnType = {
  submitDeleteBankAccount: (
    bankAccountId: string,
    reason: string
  ) => Promise<void>;
  isDeletePending: boolean;
};

export const useDeleteBankAccountMutation =
  (): UseDeleteBankAccountMutationReturnType => {
    const { showSuccess, showError } = useNotification();

    const { mutateAsync, isPending: isDeletePending } = useDeleteBankAccount();

    const onSuccess = (): void => {
      showSuccess({
        title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
        message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
      });
    };

    const onError = (error: AxiosError): void => {
      showError({
        title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
        message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
        error,
      });
    };

    const submitDeleteBankAccount = async (
      bankAccountId: string,
      reason: string
    ): Promise<void> => {
      await mutateAsync(
        {
          bankAccountId,
          data: { reason },
        },
        { onSuccess, onError }
      );
    };

    return { submitDeleteBankAccount, isDeletePending };
  };
